import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-adoption-stage',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './adoption-stage.component.html',
  styleUrl: './adoption-stage.component.scss',
})
export class AdoptionStageComponent {
  @Input() value = 0;

  steps = [
    { label: 'Preparation' },
    { label: 'Implementation' },
    { label: 'Support' },
  ];
}
